import API, { API as Instance } from './API';

const path = `inscricao`;

const InscricaoService = {
    // LISTAR UM
    find: async id => await API.find(path, id),

    // ADICIONAR
    add: async (inep, inscricao) => await API.add(`${path}/${inep}`, inscricao),

    // EDITAR
    edit: async (inep, inscricao) => await API.edit(path, inep, inscricao),

    // REMOVER
    remove: async id => await API.remove(path, id),

    informarParticipantes: async (inep, inscricao) => await Instance.put(`${path}/${inep}/informar-participantes`, inscricao),

    buscarDadosFatura: async(codigoMec) => await Instance.get(`${path}/dados-fatura/${codigoMec}`),
    salvarDadosFatura: async (inep, inscricao) => await API.add(`${path}/dados-fatura/${inep}`, inscricao),

    verificarOrdenacao: async () => await Instance.get(`${path}/verificar-ordenacao`),
    ordenarEscolasIncritas: async () => await Instance.post(`${path}/ordenar-impressao`),

    verificarCalculoMateriais: async () => await Instance.get(`${path}/verificar-calculo`),
    calcularMateriaisEscolasInscritas: async () => await Instance.post(`${path}/calcular-materiais`),

    calcularValorPagamento: async filters => await API.filters(`${path}/calcular-valor-pagamento`, filters), 

    finalizarLancamentoNotas: async codigoMec => await Instance.post(`${path}/${codigoMec}/finalizar-lancamento-notas`),
    listarPremiados: async (codigoMec, nivel) => await Instance.get(`${path}/${codigoMec}/premiados/${nivel}`),
    buscarProximoEmpate: async codigoMec => await Instance.get(`${path}/${codigoMec}/premiados/proximo-empate`),
    resolverEmpate: async (codigoMec, objeto) => await API.add(`${path}/${codigoMec}/premiados/resolver-empate`, objeto),
    resetarPremiacao: async codigoMec => await Instance.post(`${path}/${codigoMec}/premiados/resetar`),
}

export const ReciboService = {
    // EXPORTAR
    export: async (id, filters) => await API.export(`${path}/${id}/recibo`, filters),

    // RECIBO
    receipt: async id => await API.list(`${path}/${id}/recibo`),
}

export default InscricaoService;